export default __webpack_public_path__ + "static/media/Popcorn.1cc734a5.svg";